import styles from './Pill.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface PillProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'default';
  onRemove?: () => void;
  onClick?: () => void;
  className?: string;
}

export function Pill({
  children,
  variant = 'default',
  onRemove,
  onClick,
  className = '',
}: PillProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <span
      className={`${styles.pill} ${styles[variant]} ${onClick ? styles.clickable : ''} ${className}`}
      onClick={handleClick}
    >
      <span className={styles.content}>{children}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.removeBtn}
          onClick={handleRemove}
          aria-label="Remove"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </span>
  );
}
